import { matchesOtherProductCategories } from '../../../../reusable-components/datagrid/custom-filters/filterMatchesOtherProductCategories';

export function catalogCategoryFilter(col, row, value, word) {
  const normalizeString = (str) => str?.replace(/[^a-z0-9\s]/gi, '')?.toLowerCase();
  const colsToCheck = ['category', 'subcategory', 'displayCategory', 'displaySubcategory'];
  if (colsToCheck.includes(col.field)) {
    const matchesAdditional = matchesOtherProductCategories(row, col.field, (v) => normalizeString(String(v))?.includes(word));
    return (Array.isArray(value)
      ? value.some((element) => normalizeString(String(element))?.includes(word))
      : normalizeString(String(value))?.includes(word)
    ) || matchesAdditional;
  }
  if (Array.isArray(value)) {
    return value.some((element) => normalizeString(String(element))?.includes(word));
  }
  return value && normalizeString(String(value))?.includes(word);
}